// extracted by mini-css-extract-plugin
module.exports = {"container":"_2qvE2X5vEfRz3LrBdy0pLh","show-as-tag":"_1glz8GdGL12Do6EbG6YmbR","showAsTag":"_1glz8GdGL12Do6EbG6YmbR"};